"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const IValidation_1 = require("./IValidation");
const Yup = __importStar(require("yup"));
const helper_1 = require("./helper");
const triggerSchema = Yup.object()
  .shape({
    alarm: Yup.object().shape({
      active: Yup.boolean().required(),
      value: Yup.object().shape({
        namespace: Yup.string(),
        metricNames: Yup.array().of(Yup.string()),
        statistics: Yup.array().of(Yup.string()),
        dimensions: Yup.string()
      })
    }),
    http: Yup.object().shape({
      active: Yup.boolean().required(),
      value: Yup.object().shape({
        url: Yup.string(),
        userSchema: Yup.string()
      })
    }),
    event: Yup.object().shape({
      /// active is not required to provide backward compatibility with existing templates and workflow
      active: Yup.boolean(),
      value: Yup.object().shape({
        eventIds: Yup.array().of(Yup.string()),
        pattern: Yup.mixed()
      })
    }),
    schedule: Yup.object().shape({
      active: Yup.boolean().required(),
      value: Yup.array().of(Yup.mixed())
    })
  })
  .required();
class TriggerNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    // console.log(data && triggerSchema.validateSync(data))
    let isValidResult = helper_1.isValid(
      [
        { schema: triggerSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() }
      ],
      node.getNodeId()
    );
    return !(!isValidResult || !data);
  }
}
exports.TriggerNodeValidation = TriggerNodeValidation;
//# sourceMappingURL=TriggerNodeValidation.js.map
